import type { Address, Customer } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'

/**
 * Fill a carrier-bound address's missing `name` / `phone` from the customer it belongs to.
 *
 * ShipEngine rejects a payload with an empty name or phone (HTTP 400: "'name' should not be
 * empty. / 'phone' should not be empty."), and a stored address routinely has neither set, so
 * every carrier-bound address passes through here first. The address's own value always wins;
 * the customer is only the fallback. Blank-but-present names count as absent — a whitespace-only
 * `name` is what the carrier rejects.
 *
 * Returns a new Address; the input is never mutated. Every other field is copied through, so a
 * caller that also overrides `company`/`email` spreads the result and sets them after.
 */
export const enrichAddressWithCustomer = (address?: Address, customer?: Customer): Address =>
  ({
    ...address,
    name: !isEmpty(address?.name?.trim()) ? address?.name : customer?.profile?.name,
    phone: !isEmpty(address?.phone) ? address?.phone : customer?.phone,
  }) as Address
